<h1 mat-dialog-title>{{ data.label || (data.labelKey | transloco) }}</h1>
<mat-dialog-content>
    <div class="!ml-2 !mr-2 !mt-4 flex flex-col gap-4">
        <arc-button type="stroked" prefixIcon="translate" class="ml-auto" (clicked)="translateEmptyValues()" [isLoading]="isTranslating()">
            {{ 'Components.TranslationDialog.AutoTranslate' | transloco }}
        </arc-button>
        <arc-input labelKey="General.Languages.German" [control]="formGroup.controls.valueDe" />
        <arc-input labelKey="General.Languages.English" [control]="formGroup.controls.valueEn" />
        <arc-input labelKey="General.Languages.French" [control]="formGroup.controls.valueFr" />
        <arc-input labelKey="General.Languages.Italian" [control]="formGroup.controls.valueIt" />
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-stroked-button mat-dialog-close>{{ 'General.Actions.Cancel' | transloco }}</button>
    <button mat-flat-button color="accent" (click)="onSave()">{{ 'General.Actions.Save' | transloco }}</button>
</mat-dialog-actions>
